import { getIdTokenResult } from 'firebase/auth';

const getCustomClaims = async (user) => {
  const { claims } = await getIdTokenResult(user);

  return claims;
};

export default getCustomClaims;
